module.exports = __webpack_public_path__ + "img/logo@3x.b2d424c2.png";